import { Platform } from 'react-native'
import type { Theme } from '../../theme/getTheme'

export const getChallengesSectionsStyleSheet = (theme: Theme) => ({
  showMoreButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center' as const,
    marginTop: 8,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
  },
  showMoreText: {
    fontSize: 14,
    color: theme.white,
    fontWeight: '600' as const,
  },
  sectionContainer: {
    marginBottom: 14,
  },
  sectionContainerPressed: { opacity: 0.8 },
  sectionContainerHover: { opacity: 0.9 },
  sectionCard: {
    backgroundColor: theme.background.card,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.gray[300],
    padding: 10,
    overflow: 'hidden' as const,
    borderLeftWidth: 3,
    borderLeftColor: theme.primaryLight || theme.primary,
  },
  sectionHeader: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    marginBottom: 8,
    paddingHorizontal: 2,
    gap: 6,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: '700' as const,
    color: theme.black,
  },
  sectionHeaderSpacer: {
    flex: 1,
  },
  sectionHeaderCollapseButton: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    gap: 4,
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 8,
  },
  sectionHeaderCollapseButtonPressed: {
    opacity: 0.7,
  },
  sectionHeaderCollapseButtonHover: {
    opacity: 0.85,
  },
  sectionBadgePill: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 10,
    gap: 3,
  },
  sectionBadgePillError: {
    backgroundColor: theme.error,
  },
  sectionBadgePillSuccess: {
    backgroundColor: theme.success,
  },
  sectionBadgePillWarning: {
    backgroundColor: theme.warning,
  },
  sectionBadgePillNeutral: {
    backgroundColor: theme.gray[500],
  },
  sectionBadgeText: {
    fontSize: 11,
    fontWeight: '700' as const,
    color: theme.textOnStatusBadge,
  },
  historyPreviewSeeAllRow: {
    marginTop: 10,
    marginHorizontal: 2,
    borderRadius: 10,
    backgroundColor: theme.primaryLight ? `${theme.primaryLight}18` : theme.gray[100],
    borderWidth: 1,
    borderColor: theme.primaryLight ? `${theme.primaryLight}28` : theme.gray[200],
    paddingVertical: 11,
    paddingHorizontal: 16,
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    gap: 5,
  },
  historyPreviewSeeAllRowPressed: {
    opacity: 0.7,
  },
  historyPreviewSeeAllRowHover: {
    backgroundColor: theme.primaryLight ? `${theme.primaryLight}28` : theme.gray[200],
  },
  historyPreviewSeeAllText: {
    fontSize: 13,
    fontWeight: '700' as const,
    color: theme.primary,
    letterSpacing: 0.2,
  },
  filterBarRow: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    paddingHorizontal: 0,
    paddingVertical: 6,
    paddingBottom: 8,
    gap: Platform.OS === 'web' ? 12 : 10,
    marginBottom: 0,
  },
  filterBarSkeletonRow: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    paddingVertical: 6,
    paddingBottom: 8,
    gap: Platform.OS === 'web' ? 12 : 10,
    marginBottom: 0,
  },
  filterBarSkeletonPill: {
    borderRadius: 18,
    overflow: 'hidden' as const,
    width: 72,
    height: 28,
  },
  filterButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 18,
    backgroundColor: theme.primaryLight
      ? `${theme.primaryLight}20`
      : theme.gray[200],
    borderWidth: 0,
  },
  filterButtonActive: {
    backgroundColor: theme.primary,
  },
  filterButtonPressed: { opacity: 0.8 },
  filterButtonHover: { opacity: 0.9 },
  filterButtonText: {
    fontSize: Platform.OS === 'web' ? 11 : 10,
    fontWeight: '600' as const,
    color: theme.gray[700],
  },
  filterButtonTextActive: {
    fontSize: Platform.OS === 'web' ? 11 : 10,
    fontWeight: '700' as const,
    color: theme.white,
  },
  loadMoreContainer: {
    paddingBottom: 16,
  },
  loadMoreButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
    backgroundColor: theme.primaryLight
      ? `${theme.primaryLight}30`
      : theme.gray[200],
    borderWidth: 1,
    borderColor: theme.gray[300],
  },
  loadMoreButtonText: {
    fontSize: 14,
    fontWeight: '600' as const,
    color: theme.primary,
  },
})
